<div class="page">
    <div class="row">
        <div class="col-md-12">
            <h1>{{title}}</h1>
        </div>
    </div>
</div>

